import React from 'react';
import { connect } from 'react-redux';

const setting = {
  color: {
    theme: '#000',
  },
  webWidget: {
    chat: {
      suppress: true,
    },
  },
  onLoaded: () => console.log('zendesk loaded'),
  onError: (e) => console.log('failed zendesk loading', e),
};

export default (WrappedComponent) => {
  if (typeof window !== "undefined") {
    window.zESettings = setting;
  }

  const Component = (props) => (
    <WrappedComponent
      {...props}
      openChat={() => {
        window?.zE('messenger:set', 'zIndex', 99999);
        window?.zE('messenger', 'open');
        window?.zE('messenger', 'show');
      }}
      closeChat={() => window?.zE('messenger', 'close')}
    />
  );

  const ComponentWithConfig = connect((state) => ({
    configuration: state.app.context.project.configuration,
  }))(Component);

  return ComponentWithConfig;
};
